import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import PatternListModal, { NoPatternListModal } from './PatternListModal';
import { useEffect, useState } from 'react';

import FilterBox from './FilterBox';
import AlgorithmService from '../../../service/auction/AlgorithmService';

import {
  ListDataProps,
  MyPatternListProps,
  RecommendFilter,
} from '../../../interface/aiAnalyze/aiRecommend/type';
import Footer from '../../components/footer/Footer';
import PageTop from '../../components/pageTop/PageTop';
import List from '../../components/list/List';
import AddInterestItemModal from '../../components/modal/AddInterestItem';
import { useModal } from '../../../context/ModalContext';
import GuideSection from '../../guideLanding/GuideSection';
import { useUser } from '../../../context/UserContext';
import QuotaService from '../../../service/quota/Quota';
import { gradeInfo } from '../myAlgorithm/formatOptions';
import RecommendAlgorithm from './RecommendAlgorithm';
import { SortOption } from '../../components/list/data';
import { isLogin } from '../../../utils/auth';
import LimitFilter from '../../components/limit/LimitFilter';
import { sampleList } from './data';
import { PageContainer } from '../../components/common/PageComponent.style';

const AiRecommendation = () => {
  const { user } = useUser();
  const INITIAL_SELECTED_ITEM: MyPatternListProps = {
    algorithm_idx: 0,
    pnu: '',
    category: '',
    category_detail: '',
    investment_period: '',
    investment_purpose: '',
    aging_start_year: '',
    aging_end_year: '',
    zoning: '',
    revenue_type: '',
    cost_included: '',
    investment_type: '',
    min_investment_value: '',
    max_investment_value: '',
    investment_rate: '',
    profit_rate: '',
    min_bid_cnt: '',
    max_bid_cnt: '',
    risk: '',
    prc_reliability: '',
    auction_date_years: '',
    create_time: '',
    is_saved: '',
    name: '',
    grade: 0,
    regionAccess: false,
    profit_status: '',
    value_status: '',
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [myPatternList, setMyPatternList] = useState<MyPatternListProps[]>([]);
  const [recommendAlgorithmList, setRecommendAlgorithmList] = useState<
    MyPatternListProps[]
  >([]);

  const [page, setPage] = useState<number>(1); // API 요청용 페이지 번호
  const [limit, setLimit] = useState<number>(20);
  const [total, setTotal] = useState<number>(0);
  const [listData, setListData] = useState<ListDataProps[]>([]);

  const [sort, setSort] = useState<SortOption>({
    value: 'DA',
    label: '매각기일 빠른순',
  });
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const [isRecommend, setIsRecommend] = useState(true);
  const [selectedItem, setSelectedItem] = useState<MyPatternListProps>(
    INITIAL_SELECTED_ITEM,
  );

  const [filter, setFilter] = useState<RecommendFilter>({
    pnu: '',
    category: '',
    categoryDetail: '',
    minPrice: '',
    maxPrice: '',
  });
  const [selectedIdx, setSelectedIdx] = useState(0);
  const [showLikeModal, setShowLikeModal] = useState(false);
  const [selectedItem2, setSelectedItem2] = useState({
    iidx: 0,
    group: '',
    group_idx: 0,
    level: 0,
    memo: '',
  });
  const [activeItem, setActiveItem] = useState<number | null>(null);
  const [mode, setMode] = useState<string>('add');
  const isFree = !user?.plan_grade && isLogin();

  const { modalDispatch } = useModal();

  const getList = async () => {
    if (!isLogin()) return;
    try {
      const res = await AlgorithmService.getAlgorithmList('Y', 20, 1);
      setMyPatternList(res.data.list);
    } catch (error) {
      console.log(error);
    }
  };

  // 기본 제공 알고리즘
  const fetchRecommendPatterns = async () => {
    try {
      const res = await AlgorithmService.getRecommendAlgorithmList(limit, page);

      setRecommendAlgorithmList(res.data || []);
    } catch (error: any) {
      console.error('[fetchRecommendPatterns 에러]', error);
      if (error.response) {
        console.error('[서버 응답 에러]', error.response.data);
      }
    }
  };

  const getAlgorithmRecommend = async () => {
    if (!isLogin()) return;
    setLoading(true);
    try {
      const res = await AlgorithmService.getAlgorithmRecommend(
        selectedItem.algorithm_idx,
        sort.value,
        limit,
        page,
        filter?.pnu || '',
        filter?.category || '',
        filter?.categoryDetail || '',
        filter.minPrice ? Number(filter.minPrice) : undefined,
        filter.maxPrice ? Number(filter.maxPrice) : undefined,
      );

      setListData(res.data.list);
      setTotal(res.data.totalCount);
      if (!isRecommend) {
        serviceQuota(selectedItem.algorithm_idx);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // 서비스 이용권 사용
  const serviceQuota = async (p_idx: number) => {
    try {
      const data = {
        type: 'E',
        algorithmIdx: p_idx,
      };
      await QuotaService.use(data);
    } catch (err) {
      console.log(err, '발생');
    }
  };

  useEffect(() => {
    getList();
    fetchRecommendPatterns();
  }, []);

  useEffect(() => {
    if (location.state) {
      setSelectedItem(location.state.selectedItem);
      if (location.state.isRecommend) {
        setIsRecommend(true);
      } else {
        setIsRecommend(false);
      }
    }
    if (
      (!location.state || !selectedItem.algorithm_idx) &&
      recommendAlgorithmList.length > 0
    ) {
      setSelectedItem(recommendAlgorithmList[0]);
      setIsRecommend(true);
    }
  }, [location.state, recommendAlgorithmList]);

  useEffect(() => {
    if (selectedItem.algorithm_idx && !isFree) {
      getAlgorithmRecommend();
    }
  }, [filter, sort]);

  return (
    <PageContainer>
      <PageTop text="알고리즘 추천물건" />
      <Content>
        <Inner>
          <GuideSection type="algorithm" />
          <PatternBox>
            {!isRecommend ? (
              <LoadMyPatternButton
                onClick={() => {
                  setIsModalOpen(true);
                }}
                active={true}
              >
                <LoadMyPatternTitle
                  style={{
                    color: gradeInfo[selectedItem?.grade]?.color ?? '#222',
                  }}
                >
                  {gradeInfo[selectedItem?.grade]?.title ?? selectedItem.grade}
                  <img src="/assets/images/icon/icon_rotate.svg" alt="" />
                </LoadMyPatternTitle>
                <LoadMyPatternTitle02>
                  {selectedItem.name && selectedItem.name.trim() !== ''
                    ? `${selectedItem.name}`
                    : `나만의 알고리즘 ${selectedItem.algorithm_idx}`}
                </LoadMyPatternTitle02>
                <ChangePatternButton>적용중</ChangePatternButton>
              </LoadMyPatternButton>
            ) : (
              <LoadMyPatternButton
                onClick={async () => {
                  if (!isLogin()) {
                    modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
                    return;
                  }
                  if (!user?.plan_grade) {
                    modalDispatch({ type: 'USER_ALERT', payload: 'free' });
                    return;
                  }
                  setIsModalOpen(true);
                }}
                active={false}
              >
                <img src="/assets/images/plus/plus-gray-new.svg" alt="" />
                <span>나만의 알고리즘</span>
              </LoadMyPatternButton>
            )}
            {recommendAlgorithmList.length > 0 && (
              <RecommendAlgorithm
                list={recommendAlgorithmList}
                selectedItem={selectedItem}
                setSelectedItem={setSelectedItem}
                setIsRecommend={setIsRecommend}
              />
            )}
          </PatternBox>
          <FilterBox
            selectedItem={selectedItem}
            filter={filter}
            setFilter={setFilter}
          />
        </Inner>

        <ListBox>
          {isFree ? (
            <LimitFilter title="알고리즘 추천물건은" isCenter={false}>
              <List
                data={sampleList}
                totalCount={total}
                sort={sort}
                setSort={setSort}
                setOffset={setPage}
                limit={limit}
                loading={false}
                page="search"
                setSelectedIdx={setSelectedIdx}
                setShowLikeModal={setShowLikeModal}
                setMode={setMode}
                setSelectedItem={setSelectedItem2}
                activeItem={activeItem}
                setActiveItem={setActiveItem}
                getList={getAlgorithmRecommend}
              />
            </LimitFilter>
          ) : (
            <List
              data={listData}
              totalCount={total}
              sort={sort}
              setSort={setSort}
              setOffset={setPage}
              limit={limit}
              loading={loading}
              page="search"
              setSelectedIdx={setSelectedIdx}
              setShowLikeModal={setShowLikeModal}
              setMode={setMode}
              setSelectedItem={setSelectedItem2}
              activeItem={activeItem}
              setActiveItem={setActiveItem}
              getList={getAlgorithmRecommend}
            />
          )}
          {showLikeModal && (
            <AddInterestItemModal
              setShowLikeModal={setShowLikeModal}
              selectedIdx={selectedIdx}
              mode={mode}
              selectedItem={selectedItem2}
              getList={getAlgorithmRecommend}
              sort={sort}
              setActiveItem={setActiveItem}
            />
          )}
        </ListBox>
      </Content>
      <Footer />
      {isModalOpen && myPatternList.length > 0 && (
        <PatternListModal
          setIsModalOpen={setIsModalOpen}
          data={myPatternList}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          setIsRecommend={setIsRecommend}
        />
      )}
      {isModalOpen && myPatternList.length === 0 && (
        <NoPatternListModal setIsModalOpen={setIsModalOpen} />
      )}
    </PageContainer>
  );
};

export default AiRecommendation;

const Container = styled.div`
  width: 100%;
  font-family: Spoqa Han Sans Neo;
  position: relative;
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Inner = styled.div`
  display: flex;
  padding: 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const PatternBox = styled.div`
  width: calc(100dvw - 16px);
  max-width: 900px;
  display: flex;
  gap: 16px;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding-bottom: 4px;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const LoadMyPatternButton = styled.div<{ active: boolean }>`
  min-width: 180px;
  height: 130px;
  flex: 0 0 auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => (props.active ? 'space-between' : 'center')};
  align-items: ${(props) => (props.active ? 'start' : 'center')};
  gap: 5px;
  border-radius: 12px;
  border: ${(props) => (props.active ? '1px solid #008aff' : 'none')};
  font-size: 14px;
  font-weight: 500;
  color: #222;
  cursor: pointer;
  background-color: ${(props) =>
    props.active ? '#EAF2FE' : 'rgba(112, 115, 124, 0.08)'};
`;

const ChangePatternButton = styled.span`
  color: #616161;

  /* Re_SPOQA/body/med_14 */
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
`;
const ListBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const LoadMyPatternTitle = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
  color: #008aff;
`;

const LoadMyPatternTitle02 = styled.div`
  color: #222;

  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
`;
